// 🔧 social_repository.js
// ✅ Purpose: Firestore repository for Social Engine demo draft posts
// ✅ Features:
// - Writes social draft post documents
// - Uses Firestore-generated document IDs
// - Uses production-style event-scoped collection path
// - Does NOT publish to any real social platform
// - Fully block-commented for clarity and future devs

import {
  collection,
  doc,
  writeBatch,
  serverTimestamp,
} from "firebase/firestore";

import { db } from "../../../firebase";

export const saveSocialPosts = async ({
  demoContext,
  posts = [],
} = {}) => {
  console.log("💾 Saving Social Engine demo data.");

  const eventId =
    demoContext?.eventId ||
    demoContext?.eventResult?.eventId ||
    demoContext?.event?.eventId;

  if (!eventId) {
    throw new Error("Social Repository requires an eventId.");
  }

  if (posts.length === 0) {
    return {
      posts: [],
    };
  }

  const batch = writeBatch(db);
  const savedPosts = [];

  posts.forEach((post) => {
    const postRef = doc(
      collection(db, "promotion_posts")
    );

    const postData = {
      ...post,

      eventId,
      scope: "event",
      queueStatus: post.queueStatus || "draft",
      publishStatus: post.publishStatus || "draft",

      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),

      demoSeed: true,
    };

    batch.set(postRef, postData);

    savedPosts.push({
      ...postData,
      id: postRef.id,
    });
  });

  await batch.commit();

  console.log("✅ Social Engine repository completed.", {
    posts: savedPosts.length,
  });

  return {
    posts: savedPosts,
  };
};
